import { cn as e } from "../cn.js";
import { getStyles as t } from "./style.js";
import { createContext as n, useContext as r } from "react";
import { jsx as i } from "react/jsx-runtime";
// src/design/timeline/index.tsx
var a = n({}), o = () => r(a), s = {
	Root: ({ children: n, className: r, config: o, ...s }) => {
		let c = t(o);
		return /* @__PURE__ */ i(a.Provider, {
			value: { config: o },
			children: /* @__PURE__ */ i("div", {
				className: e(c.root(), r),
				...s,
				children: n
			})
		});
	},
	Item: ({ children: n, className: r, config: a, ...s }) => {
		let { config: c } = o(), l = t(a || c);
		return /* @__PURE__ */ i("div", {
			className: e(l.item(), r),
			...s,
			children: n
		});
	},
	Connector: ({ children: n, className: r, config: a, ...s }) => {
		let { config: c } = o(), l = t(a || c);
		return /* @__PURE__ */ i("div", {
			className: e(l.connector(), r),
			...s,
			children: n
		});
	},
	Separator: ({ className: n, config: r, ...a }) => {
		let { config: s } = o(), c = t(r || s);
		return /* @__PURE__ */ i("div", {
			className: e(c.separator(), n),
			...a
		});
	},
	Indicator: ({ children: n, className: r, config: a, ...s }) => {
		let { config: c } = o(), l = t(a || c);
		return /* @__PURE__ */ i("div", {
			className: e(l.indicator(), r),
			...s,
			children: n
		});
	},
	Content: ({ children: n, className: r, config: a, ...s }) => {
		let { config: c } = o(), l = t(a || c);
		return /* @__PURE__ */ i("div", {
			className: e(l.content(), r),
			...s,
			children: n
		});
	},
	Title: ({ children: n, className: r, config: a, ...s }) => {
		let { config: c } = o(), l = t(a || c);
		return /* @__PURE__ */ i("h4", {
			className: e(l.title(), r),
			...s,
			children: n
		});
	},
	Description: ({ children: n, className: r, config: a, ...s }) => {
		let { config: c } = o(), l = t(a || c);
		return /* @__PURE__ */ i("p", {
			className: e(l.description(), r),
			...s,
			children: n
		});
	},
	getStyles: t
};
export { s as Timeline };

//# sourceMappingURL=index.js.map